import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UIState {
  sidebar: {
    isMinimized: boolean
  }
}

const initialState: UIState = {
  sidebar: {
    isMinimized: false
  }
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebar.isMinimized = !state.sidebar.isMinimized
    },
    setSidebarMinimized: (state, action: PayloadAction<boolean>) => {
      state.sidebar.isMinimized = action.payload
    }
  }
})

export const { toggleSidebar, setSidebarMinimized } = uiSlice.actions

export default uiSlice.reducer